	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Interface.GrimoireInterface;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Interface/GrimoireInterface.js
// module id = 118
// module chunks = 0